var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.084,
    height: 12.168,
    viewBox: "0 0 7.084 12.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back_Button",
    "data-name": "Back Button",
    transform: "translate(1.414 1.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(4.67 9.34) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M4.67,0,0,4.67,4.67,9.34",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/Next-Button.fcb27823ca32a5008f2b1f5130641bd6.svg";
export { ForwardRef as ReactComponent };